export default "__VITE_ASSET__53ceecd3__"